import { Layout, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { ReconcileFileUpload } from '../components/Reconcile/ReconcileFileUpload.component';
import { StatementListTable } from '../components/Reconcile/StatementListTable.component';
import { StatementReconciliationHeader } from '../components/Reconcile/StatementReconciliationHeader.component';

export const Reconcile: React.FC = () => {
  return (
    <Layout.Column py={24} px={32} grow style={{ height: '100vh', overflow: 'scroll' }}>
      <Layout.Row style={{ minWidth: 1000 }}>
        <Spacer.Flex />
        <Layout.Column style={{ width: '100%' }}>
          <StatementReconciliationHeader />
          <Spacer.Vertical size={16} />
          <ReconcileFileUpload />
          <Spacer.Vertical size={16} />
          <StatementListTable />
        </Layout.Column>
        <Spacer.Flex />
      </Layout.Row>
    </Layout.Column>
  );
};
